import './assets/main.css'

import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'
import App from './App.vue'
import i18n from './utils/i18n.js'
import * as amplitude from '@amplitude/analytics-browser'

const app = createApp(App)
const mode = import.meta.env.MODE

if (!!import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: __APP_VERSION__,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration()
    ],
    sendDefaultPii: true // required for httpClientIntegration
  })
}

if (mode === 'staging' || mode === 'staging-china') {
  import('eruda').then((eruda) => eruda.default.init())
}

if (!!import.meta.env.VITE_AMPLITUDE_API_KEY) {
  const currentHost = window.location.hostname
  const reducedSampleRateHosts =
    import.meta.env.VITE_AMPLITUDE_REDUCED_SAMPLE_RATE_HOSTS?.split(',') || []
  const reducedSampleRate =
    parseFloat(import.meta.env.VITE_AMPLITUDE_REDUCED_SAMPLE_RATE) || 0.1
  const sampleRate = reducedSampleRateHosts.includes(currentHost)
    ? reducedSampleRate
    : 1

  amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, {
    defaultTracking: false,
    useDynamicConfig: true,
    sampleRate: sampleRate
  })
}

app.use(i18n)
app.mount('#app')
